export const DOCUMENT_TYPE_OPTIONS = [
	{ id: 1, label: "CRLV" },
	{ id: 2, label: "Seguro" },
	{ id: 3, label: "Outro" },
] as const;
